import NextStepButton from './NextStepButton'

const components = {
  NextStepButton,
}

export default {
  // eslint-disable-next-line no-unused-vars
  install(Vue, options) {
    Object.keys(components).forEach(component => Vue.component(component, components[component]))
  },
}
